import React from 'react';

var NotificationWr = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: 'pgc-notification-container' }, children);
};

export { NotificationWr };
